import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-zinc-900 ${className}`} data-id="element-295">
      <div className="container mx-auto px-4" data-id="element-296">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-297">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-298">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-black/70 p-6 rounded-2xl shadow-lg border border-emerald-900/40 flex flex-col h-full" data-id="element-299">
              <div className="flex items-center gap-1 mb-4" data-id="element-300">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-emerald-400 fill-emerald-400" data-id="element-301" />)}
              </div>

              <p className="text-zinc-100 italic mb-6 flex-grow" data-id="element-302">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-emerald-900/30" data-id="element-303">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-304">
                  {t.initials}
                </div>
                <div data-id="element-305">
                  <p className="font-bold text-white text-sm" data-id="element-306">{t.name}</p>
                  <p className="text-xs text-emerald-200" data-id="element-307">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-emerald-300 mt-0.5" data-id="element-308">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MR',
  name: 'Martín R.',
  location: 'Profesional de IT · Buenos Aires',
  text: 'Llevaba años trabajando con brasileños usando el traductor. Abrí el Tomo 1 y entendí por qué nunca había avanzado. No era que el portugués era difícil — era que nadie me lo había explicado desde el español rioplatense.',
  color: 'bg-emerald-600'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Diseñadora freelance · Rosario',
  text: 'Cerré mi primer contrato con una empresa de São Paulo en un mes. Las frases listas para WhatsApp me cambiaron todo.',
  color: 'bg-green-700'
}, {
  initials: 'FP',
  name: 'Federico P.',
  location: 'Emprendedor · Mendoza',
  text: 'Perdí varios clientes brasileños por no animarme a hablar. Después del Tomo 3 tengo dos clientes fijos en Brasil.',
  color: 'bg-emerald-700'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'JM',
  name: 'Julián M.',
  location: '🏙️ Buenos Aires',
  pack: 'Megapack Portugués',
  text: 'Dos años "aprendiendo" con apps y sin avanzar. Con el sistema de este Megapack en tres semanas tuve mi primera conversación real en portugués.',
  color: 'bg-emerald-700'
}, {
  initials: 'DS',
  name: 'Daniela S.',
  location: '🏙️ Santa Fe',
  pack: 'Megapack Portugués',
  text: 'El Tomo 3 me dio estrategias para mantener una conversación aunque no entienda todo. Eso cambió todo.',
  color: 'bg-green-800'
}, {
  initials: 'CP',
  name: 'Carlos P.',
  location: '🏙️ Tucumán',
  pack: 'Megapack + Nivel PRO',
  text: 'Con el Nivel PRO ahora participo activo en los plannings de mi cliente de São Paulo.',
  color: 'bg-emerald-800'
}, {
  initials: 'MG',
  name: 'Marcela G.',
  location: '🏙️ Rosario',
  pack: 'Megapack + Nivel PRO',
  text: 'Cerré 3 proyectos nuevos con agencias brasileñas el mes pasado. El sistema funciona.',
  color: 'bg-emerald-900'
}, {
  initials: 'MV',
  name: 'Mariana V.',
  location: '🏙️ Córdoba',
  pack: 'Megapack Portugués',
  text: 'Viajé a Florianópolis y por primera vez pude resolver un problema con el hotel sin usar el traductor ni hablar en español.',
  color: 'bg-green-900'
}];